import { render, staticRenderFns } from "./SendNotify.vue?vue&type=template&id=591855ee&scoped=true&"
import script from "./SendNotify.vue?vue&type=script&lang=js&"
export * from "./SendNotify.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "591855ee",
  null
  
)

export default component.exports